import { DetailedRecurrenceFrequency, RecurrenceFrequency } from '@pflegix/types';
import { assertUnreachable } from './assert-unreachable.util';

/**
 * Returns the detailed recurrence frequency based on the given frequency type and interval.
 *
 * @param frequencyType - The type of recurrence frequency.
 * @param frequencyInterval - The interval of the recurrence frequency.
 * @returns The detailed recurrence frequency.
 */
export function getDetailedRecurrenceFrequency(
  frequencyType: RecurrenceFrequency,
  frequencyInterval: number
): DetailedRecurrenceFrequency {
  switch (frequencyType) {
    case RecurrenceFrequency.DAILY: {
      return DetailedRecurrenceFrequency.DAILY;
    }
    case RecurrenceFrequency.WEEKLY: {
      if (frequencyInterval === 2) {
        return DetailedRecurrenceFrequency.BI_WEEKLY;
      }
      if (frequencyInterval === 3) {
        return DetailedRecurrenceFrequency.EVERY_THREE_WEEKS;
      }
      if (frequencyInterval === 4) {
        return DetailedRecurrenceFrequency.EVERY_FOUR_WEEKS;
      }

      return DetailedRecurrenceFrequency.WEEKLY;
    }
    case RecurrenceFrequency.MONTHLY: {
      if (frequencyInterval === 3) {
        return DetailedRecurrenceFrequency.QUARTER;
      }

      if (frequencyInterval === 6) {
        return DetailedRecurrenceFrequency.HALF_YEARLY;
      }

      return DetailedRecurrenceFrequency.MONTHLY;
    }
    case RecurrenceFrequency.YEARLY: {
      return DetailedRecurrenceFrequency.YEARLY;
    }
    default: {
      return assertUnreachable(frequencyType);
    }
  }
}
